import { useEffect, useRef } from 'react';
import PubNub from 'pubnub';
import useUserDetails from './useUserDetails';

const PUBNUB_NETWORK_UP_CATEGORY_STATUS = 'PNNetworkUpCategory';

const useSchoolReportStatusChannel = (onMessage: () => void) => {
  const {
    userDetails: { data: userDetails },
    pubNubToken,
  } = useUserDetails();
  const onMessageRef = useRef(onMessage);
  onMessageRef.current = onMessage;

  useEffect(() => {
    if (!userDetails || !pubNubToken) return;

    const pubnub = new PubNub({
      subscribeKey: process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY as string,
      userId: userDetails.id,
    });
    pubnub.setToken(pubNubToken);

    const channel = pubnub.channel(`eoa.${userDetails.eoaId}.schoolreportstatuschanged`);
    const subscription = channel.subscription();

    pubnub.addListener({
      status: (status) => {
        if (status.error) console.error(`PubNub error: ${status.category}`);
        if (status.category === PUBNUB_NETWORK_UP_CATEGORY_STATUS) subscription.subscribe();
      },
    });

    subscription.onMessage = () => {
      onMessageRef.current();
    };

    subscription.subscribe();

    return () => {
      pubnub.removeAllListeners();
      pubnub.unsubscribeAll();
    };
  }, [userDetails, pubNubToken]);
};

export default useSchoolReportStatusChannel;
